import { MessageCircle } from "lucide-react";
import { waLink, WA_DEFAULT_MSG } from "@/lib/site";

const WhatsAppFloat = () => (
  <a
    href={waLink(WA_DEFAULT_MSG)}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float-button"
    aria-label="Chat with Raffiel Nias on WhatsApp"
    className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-ocean-700 text-white flex items-center justify-center shadow-xl hover:bg-ocean-600 hover:scale-105 transition-all"
  >
    <MessageCircle size={26} />
  </a>
);

export default WhatsAppFloat;
